export default __webpack_public_path__ + "static/media/FullStack.e51d8cf8.png";